import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchVenueSessions = async (venueId) => {
    const res = await axios.get(`${API_BASE_URL}/get-venue-sessions?venue_id=${venueId}`);
    return {
        sessions: res.data.sessions ?? {},
        availableDates: res.data.availableDates ?? [],
        availableClasses: res.data.availableClasses ?? [],
    };
};

export const useVenueSessions = (venueId) => {
    const { data, isLoading } = useQuery({
        queryKey: ["venueSessions", venueId],
        queryFn: () => fetchVenueSessions(venueId),
        enabled: !!venueId,
        staleTime: 5 * 60 * 1000,
    });

    return {
        sessionsByVenue: data?.sessions ?? {},
        availableDates: data?.availableDates ?? [],
        availableClasses: data?.availableClasses ?? [],
        isLoadingVenueSessions: isLoading,
    };
};
